import { render, staticRenderFns } from "./Modalidades.vue?vue&type=template&id=24a748a9"
import script from "./Modalidades.vue?vue&type=script&lang=js"
export * from "./Modalidades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports